"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsight = void 0;
const react_cirrus_1 = require("@yanzi/react-cirrus");
const react_1 = require("react");
const react_query_1 = require("react-query");
const useDeepCompareMemo_1 = require("../hooks/useDeepCompareMemo");
const InsightsProvider_1 = require("./InsightsProvider");
const queryInsights_1 = require("./queryInsights");
function useInsight(query, { variables: changingVariables, context: changingContext, isLoading, throwErrors = process.env.NODE_ENV === 'development', skip, sourceRef, }) {
    var _a;
    const { rateLimitQueue, developerQueries, backendUrl } = InsightsProvider_1.useInsightContext();
    const variables = useDeepCompareMemo_1.useDeepCompareMemo(changingVariables);
    const context = useDeepCompareMemo_1.useDeepCompareMemo(Object.assign(Object.assign({}, changingContext), { mode: (_a = changingContext.mode) !== null && _a !== void 0 ? _a : (developerQueries ? 'DEVELOPMENT' : 'PRODUCTION') }));
    const queryKey = react_1.useMemo(() => {
        const compiled = query(variables);
        return [
            'useInsight',
            {
                queryId: compiled.id,
                parameters: compiled.params,
                context,
                queueId: rateLimitQueue.id,
                backendUrl,
            },
        ];
    }, [query, variables, context, rateLimitQueue.id, backendUrl]);
    const { socket } = react_cirrus_1.useCirrus();
    const res = react_query_1.useQuery(queryKey, () => {
        const abortController = new AbortController();
        const promise = queryInsights_1.queryInsights(query, { variables, context }, {
            rateLimitQueue,
            socket,
            signal: abortController.signal,
            backendUrl,
        });
        promise.cancel = () => abortController.abort();
        return promise;
    }, {
        enabled: !skip,
        staleTime: 10 * 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });
    if (res.error && throwErrors && !react_query_1.isCancelledError(res.error)) {
        throw res.error;
    }
    const source = react_1.useMemo(() => ({ query, variables, context }), [
        query,
        variables,
        context,
    ]);
    if (sourceRef) {
        sourceRef.current = { query, variables, context };
    }
    return Object.assign(Object.assign({}, res), { isLoading: isLoading || res.isLoading, source });
}
exports.useInsight = useInsight;
//# sourceMappingURL=useInsight.js.map